import {notification} from 'antd'
import {hidePageLoad, showPageLoad} from '../../../modules/actions'
import {customAxios as axios, getToken} from '../../../request'
import {
    addExpenseWithdrawalUrl,
    addWithdrawalSendOtpUrl,
    addWithdrawalUrl, checkWithdrawalLimitUrl, listWithdrawalDataUrl,
    listWithdrawalUrl, reGenerateInvoiceUrl,
    sendExpenseWithdrawalOtpUrl, updateUniversityCommissionsUrl,
    updateWithdrawalUrl, withdrawalLimitUrl
} from '../api/withdrawalApi'
import { listUserUrl } from '../../users/api/user'

export const addWithdrawalSendOtpFxn = valData => async dispatch => {
    dispatch(showPageLoad())
    let {data} = await axios.post(
        addWithdrawalSendOtpUrl(),
        valData,
        getToken()
    )
    dispatch(hidePageLoad())

    if (!data.error) {
        notification.success({
            message: data.message || 'Success'
        })
    } else {
        notification.error({
            message: data.message || 'Error'
        })
    }
    return data
}
export const sendExpenseWithdrawalOtp = valData => async dispatch => {
    dispatch(showPageLoad())
    let {data} = await axios.post(
        sendExpenseWithdrawalOtpUrl(),
        valData,
        getToken()
    )
    dispatch(hidePageLoad())

    if (!data.error) {
        notification.success({
            message: data.message || 'Success'
        })
    } else {
        notification.error({
            message: data.message || 'Error'
        })
    }
    return data
}
export const addWithdrawalFxn = valData => async dispatch => {
    dispatch(showPageLoad())
    let {data} = await axios.post(addWithdrawalUrl(), valData, getToken())
    dispatch(hidePageLoad())

    if (!data.error) {
        notification.success({
            message: data.message || 'Success'
        })
    } else {
        notification.error({
            message: data.message || 'Error'
        })
    }
    return data
}
export const addExpenseWithdrawalFxn = valData => async dispatch => {
    dispatch(showPageLoad())
    let {data} = await axios.post(
        addExpenseWithdrawalUrl(),
        valData,
        getToken()
    )
    dispatch(hidePageLoad())

    if (!data.error) {
        notification.success({
            message: data.message || 'Success'
        })
    } else {
        notification.error({
            message: data.message || 'Error'
        })
    }
    return data
}

export const listWithdrawalFxn = filters => async dispatch => {
    // dispatch(showPageLoad())
    let config = {
        params: {...filters},
        ...(await getToken())
    }
    let {data} = await axios.get(listWithdrawalUrl(), config)
    dispatch(hidePageLoad())

    return data.data
}
export const updateWithdrawalFxn = valData => async dispatch => {
    dispatch(showPageLoad())
    let {data} = await axios.post(updateWithdrawalUrl(), valData, getToken())
    dispatch(hidePageLoad())
    if (!data.error) {
        notification.success({
            message: data.message || 'Success'
        })
    } else {
        notification.error({
            message: data.message || 'Error'
        })
    }
    return data
}

export const reGenerateInvoiceFxn = valData => async dispatch => {
    dispatch(showPageLoad())
    let {data} = await axios.post(reGenerateInvoiceUrl(), valData, getToken())
    dispatch(hidePageLoad())
    if (!data.error) {
        notification.success({
            message: data.message || 'Success'
        })
    } else {
        notification.error({
            message: data.message || 'Error'
        })
    }
    return data
}

export const updateUniversityCommissionsFxn = valData => async dispatch => {
    dispatch(showPageLoad())
    let {data} = await axios.post(updateUniversityCommissionsUrl(), valData, getToken())
    dispatch(hidePageLoad())
    if (!data.error) {
        notification.success({
            message: data.message || 'Success'
        })
    } else {
        notification.error({
            message: data.message || 'Error'
        })
    }
    return data
}

export const listWithdrawalDataFxn = filters => async dispatch => {
    let config = {
        params: {...filters},
        ...await getToken()
    }
    dispatch(showPageLoad())
    let {data} = await axios.get(listWithdrawalDataUrl(), config)
    dispatch(hidePageLoad())
    return data
}

export const checkWithdrawalLimitFxn = filters => async dispatch => {
    let config = {
        params: {...filters},
        ...await getToken()
    }
    dispatch(showPageLoad())
    let {data} = await axios.get(checkWithdrawalLimitUrl(), config)
    dispatch(hidePageLoad())
    return data
}